import Lenis from "lenis";

let lenis = null;

export function initLenis() {
    if (lenis) return lenis;
    if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return null;
    }
    lenis = new Lenis({
        duration: 1.1,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
    });
    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return lenis;
}

export function scrollToTop(immediate = true) {
    if (lenis) lenis.scrollTo(0, { immediate });
    else window.scrollTo(0, 0);
}

export function scrollToId(selector) {
    const el = document.querySelector(selector);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
}
